// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__3-hR1","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__1zzK4"};